module.exports = __webpack_public_path__ + "img/g-position-es.0ad8f68d.png";